import { useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import ProductCard from '../Product/ProductCard'

const ProductCarousel = ({ 
  products = [], 
  title = '', 
  showExploreButton = true,
  className = '' 
}) => {
  const swiperRef = useRef(null)
    
  if (!products || products.length === 0) {
    return null
  }
    
  return (
    <div className={`relative w-full ${className}`}>
      {title && (
        <h2 className="text-xl sm:text-2xl lg:text-3xl font-title text-primary-black mb-6 sm:mb-8 text-center">
          {title}
        </h2>
      )}
            
      <div className="relative overflow-hidden mx-4 sm:mx-6 lg:mx-8">
        <Swiper
          ref={swiperRef}
          modules={[Navigation, Autoplay]}
          spaceBetween={16}
          slidesPerView={1.2}
          loop={products.length > 3}
          autoplay={false}
          navigation={{
            nextEl: '.product-carousel-button-next',
            prevEl: '.product-carousel-button-prev'
          }}
          breakpoints={{
            480: {
              slidesPerView: 1.5,
              spaceBetween: 16
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            768: {
              slidesPerView: 2.5,
              spaceBetween: 20
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 24
            },
            1280: {
              slidesPerView: 3,
              spaceBetween: 24
            }
          }}
          className="!overflow-visible px-2"
        >
          {products.map((product) => (
            <SwiperSlide key={product._id}>
              <ProductCard
                product={product}
                showExploreButton={showExploreButton}
                bestSelling={true}
              />
            </SwiperSlide>
          ))}
        </Swiper>
                
        {/* Navigation Buttons - Inside container */}
        {products.length > 2 && (
          <>
            <button 
              className="product-carousel-button-prev absolute left-2 top-1/2 transform -translate-y-1/2 z-10 bg-white/90 backdrop-blur-sm shadow-lg hover:shadow-xl p-2 sm:p-3 rounded-full transition-all duration-300 group disabled:opacity-50 disabled:cursor-not-allowed"
              aria-label="Producto anterior"
            >
              <svg className="w-4 h-4 sm:w-5 sm:h-5 text-primary-gray group-hover:text-primary-black transition-colors duration-300" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            </button>
            <button 
              className="product-carousel-button-next absolute right-2 top-1/2 transform -translate-y-1/2 z-10 bg-white/90 backdrop-blur-sm shadow-lg hover:shadow-xl p-2 sm:p-3 rounded-full transition-all duration-300 group disabled:opacity-50 disabled:cursor-not-allowed"
              aria-label="Siguiente producto"
            >
              <svg className="w-4 h-4 sm:w-5 sm:h-5 text-primary-gray group-hover:text-primary-black transition-colors duration-300" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
              </svg>
            </button>
          </>
        )}
      </div>
    </div>
  )
}

export default ProductCarousel